import { FacebookSVG, InstagramSVG, LinkedinSVG, TwitterSVG } from '../../constants/svgs';
import { HStack, Link } from '@chakra-ui/react';

import React from 'react';

function SocialIcons({
  bgColor,
  hoverColor,
  iconColor,
  size,
  bgSize,
  paddingTop
}: SocialIconsProps) {
  return (
    <HStack gap="16px" pt={paddingTop}>
      <Link
        href="https://www.instagram.com/svetionikznanja/"
        aria-label="Instagram link"
        target="_blank"
      >
        <HStack
          h={bgSize}
          w={bgSize}
          bg={bgColor}
          justifyContent="center"
          borderRadius="full"
          _hover={{
            bg: hoverColor,
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: InstagramSVG(`${iconColor}`, `${size}`, `${size}`),
            }}
          />
        </HStack>
      </Link>
      <Link
        href="https://www.facebook.com/svetionikznanja"
        aria-label="Facebook link"
        target="_blank"
      >
        <HStack
          h={bgSize}
          w={bgSize}
          bg={bgColor}
          justifyContent="center"
          borderRadius="full"
          _hover={{
            bg: hoverColor,
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: FacebookSVG(`${iconColor}`, `${size}`, `${size}`),
            }}
          />
        </HStack>
      </Link>

      <Link
        href="https://www.linkedin.com/company/afirmacijakulture/"
        aria-label="Linkedin link"
        target="_blank"
      >
        <HStack
          h={bgSize}
          w={bgSize}
          bg={bgColor}
          justifyContent="center"
          borderRadius="full"
          _hover={{
            bg: hoverColor,
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: LinkedinSVG(`${iconColor}`, `${size}`, `${size}`),
            }}
          />
        </HStack>
      </Link>

      <Link
        href="https://twitter.com/SvetionikZ"
        aria-label="Twitter link"
        target="_blank"
      >
        <HStack
          h={bgSize}
          w={bgSize}
          bg={bgColor}
          justifyContent="center"
          borderRadius="full"
          _hover={{
            bg: hoverColor,
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: TwitterSVG(`${iconColor}`, `${size}`, `${size}`),
            }}
          />
        </HStack>
      </Link>
    </HStack>
  );
}

type SocialIconsProps = {
  bgColor: string;
  hoverColor: string;
  iconColor: string;
  size: string;
  bgSize: string;
  paddingTop: string;
};

export default SocialIcons;
